// SENTRY MUST BE FIRST - Initialize before any other imports
import { initializeSentry } from "./sentry";
initializeSentry();

import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "@/store";
import App from "./App.tsx";
import "./index.css";
import "./aws-config";

// check WebP support
function checkWebPSupport() {
  const canvas = document.createElement("canvas");
  canvas.width = 1;
  canvas.height = 1;
  const ctx = canvas.getContext("2d");
  if (ctx) {
    const dataURL = canvas.toDataURL("image/webp");
    const isWebPSupported = dataURL.indexOf("data:image/webp") === 0;

    if (!isWebPSupported) {
      document.documentElement.classList.add("no-webp");
    }
  }
}

// check WebP support before the application starts
checkWebPSupport();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
);
